import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "./ui/dialog";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export const RaceBadge = ({ value, testId }) =>
  value != null ? (
    <span
      data-testid={testId}
      className="inline-flex items-center h-6 px-2 rounded-md text-xs font-black tracking-wider bg-[#FF5722]/15 text-[#FF8A65] border border-[#FF5722]/40"
      title="Numero di gara"
    >
      #{value}
    </span>
  ) : null;

export const RaceNumberDialog = ({ target, onClose, onSaved }) => {
  const [value, setValue] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    setValue(target?.race_number != null ? String(target.race_number) : "");
  }, [target]);

  const save = async (rn) => {
    setBusy(true);
    try {
      await api.patch(`/submissions/${target.submission_id}/race-number`, { race_number: rn });
      toast.success(rn == null ? "Numero di gara rimosso" : `Numero di gara #${rn} assegnato`);
      onSaved(rn);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Errore salvataggio");
    } finally {
      setBusy(false);
    }
  };

  const submit = () => {
    if (!/^\d{1,4}$/.test(value) || Number(value) < 1) {
      toast.error("Inserisci un numero intero da 1 a 9999");
      return;
    }
    save(Number(value));
  };

  return (
    <Dialog open={!!target} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="race-dialog" className="bg-[#0E0E11] border-white/10 text-white max-w-sm">
        <DialogHeader>
          <DialogTitle>Numero di gara</DialogTitle>
        </DialogHeader>
        <div className="text-xs text-white/50 -mt-2 break-all">{target?.name}</div>
        <Input
          data-testid="race-input"
          inputMode="numeric"
          maxLength={4}
          autoFocus
          value={value}
          onChange={(e) => setValue(e.target.value.replace(/\D/g, "").slice(0, 4))}
          onKeyDown={(e) => e.key === "Enter" && submit()}
          placeholder="Es. 123"
          className="bg-white/5 border-white/10 text-white text-2xl font-black tracking-widest h-14 text-center"
        />
        <div className="text-[11px] text-white/40">Solo numeri interi (1–4 cifre). Univoco nella competizione.</div>
        <DialogFooter className="gap-2">
          {target?.race_number != null && (
            <Button
              variant="ghost"
              onClick={() => save(null)}
              disabled={busy}
              data-testid="race-clear"
              className="text-red-300 hover:bg-red-500/10 mr-auto"
            >
              Rimuovi
            </Button>
          )}
          <Button variant="ghost" onClick={onClose} data-testid="race-cancel" className="text-white/70 hover:bg-white/10">
            Annulla
          </Button>
          <Button
            onClick={submit}
            disabled={busy || !value}
            data-testid="race-submit"
            className="bg-gradient-to-r from-[#FF5722] to-[#00E5FF] text-white font-bold"
          >
            {busy && <Loader2 className="w-4 h-4 animate-spin mr-2" />}
            Salva
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
